<template>
  <div class="pa-4 d-flex flex-column" style="gap:12px;">
    <v-text-field v-model="local.title" label="Title" outlined dense hide-details></v-text-field>
    <v-textarea v-model="local.description" label="Description" auto-grow outlined rows="3" hide-details></v-textarea>
    <div>
      <v-btn small color="yellow darken-3" class="black--text" @click="emitUpdate">Save Concept</v-btn>
      <v-btn small class="ml-2" @click="$emit('prompt', 'Write a punchy one-sentence pitch for this idea: ' + (local.title || ''))">Ask Sparky for pitch</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IdeaConcept',
  props: { idea: { type: Object, default: () => ({}) } },
  data(){ return { local: { title: this.idea?.title || this.idea?.name || '', description: this.idea?.description || '' } } },
  watch: {
    idea: {
      deep: true,
      handler(n){ this.local.title = n?.title || n?.name || ''; this.local.description = n?.description || '' }
    }
  },
  methods: {
    emitUpdate(){ this.$emit('update', { title: this.local.title, description: this.local.description }) }
  }
}
</script>


